import { useState, useEffect } from 'react';
import {
    createProductCategories,
    deleteProductCategories,
    findCategoriesByIdProduct,
    getProductsCategories,
    updateProductCategories,
    categoriesProducIitem
} from '../services/ProductDetailService';

export const useProductDetails = () => {

    const [productDetailSingle, setProductDetailSingle] = useState([]);
    const [productDetails, setProductDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchProductDetails = async () => {
        setLoading(true);
        try {
            const response = await getProductsCategories();
            setProductDetails(response.data);
        } catch (err) {
            setError('Failed to fetch products');
        } finally {
            setLoading(false);
        }
    };

    const addProductDetails = async (productDetails) => {
        try {
            const response = await createProductCategories(productDetails);
            setProductDetails([...productDetails, response.data]);
        } catch {
            setError('Failed to add productDetails');
        }
    };

    const editProductDetails = async (id, updatedProductDetails) => {
        try {
            const response = await updateProductCategories(id, updatedProductDetails);
            setProductDetails(productDetails.map(p => (p.id === id ? response.data : p)));
        } catch {
            setError('Failed to update Product Details');
        }
    };

    const findByIdProduct = async (id) => {
        try {
            const response = await findCategoriesByIdProduct(id);
            console.log('ini dari id ', id)
            setProductDetailSingle([...productDetails, response.data]);
        } catch {
            setError('Failed to delete product');
        } finally {
            setLoading(false);
        }
    };

    const removeProductDetails = async (id) => {
        try {
            await deleteProductCategories(id);
            setProductDetails(productDetails.filter(p => p.id !== id));
        } catch {
            setError('Failed to delete product');
        }
    };

    const reloadCategoriesProducIitem = async (productDetails) => {
        console.log('tambah productDetails ', productDetails)
        try {
            const response = await categoriesProducIitem(productDetails);
            setProductDetails([...productDetails, response.data]);
        } catch {
            setError('Failed to add productDetails');
        }
    };


    useEffect(() => {
        fetchProductDetails();
    }, []);

    return { productDetailSingle, productDetails, loading, error, reloadCategoriesProducIitem, fetchProductDetails, findByIdProduct, addProductDetails, editProductDetails, removeProductDetails };

};
